import { ClientNotification, Notification, ServerNotification } from '.';

export class NotificationReceived {
  static readonly type = '[Notifications] NotificationReceived';
  constructor(public notification: Notification) { }
}

export class ShowNotification {
  static readonly type = '[Notifications] ShowNotification';
  constructor(public notification: ClientNotification) { }
}

export class LoadNotificationHistory {
  static readonly type = '[Notifications] LoadNotificationHistory';
  constructor(public options?: { limit?: number, locale?: string }) { }
}

export class LoadNotificationHistorySuccess {
  static readonly type = '[Notifications] LoadNotificationHistorySuccess';
  constructor(public data: ServerNotification[]) { }
}

export class LoadNotificationHistoryFailure {
  static readonly type = '[Notifications] LoadNotificationHistoryFailure';
  constructor(public error: any) { }
}
